var headerElement;

document.addEventListener('DOMContentLoaded', function() {
  headerElement = document.getElementById('shopify-section-sections--21705233072411__header');
  headerElement.style.backgroundColor = 'rgba(255, 255, 255, 0)';

  var proseElements = document.querySelectorAll('.prose');
  for(var proseElement of proseElements){
    var headingElement = proseElement.querySelector('.h4');
    if(headingElement){
      var aValue = headingElement.querySelector('a');
      if(aValue){
        if(aValue.innerHTML === 'Lifestyle'){
          aValue.style.color = "#000";
          headingElement.style.width = "360px";
          if(window.innerWidth < 700){
            headingElement.style.transform = 'rotate(0deg)';
          }
          break;
        }
      }
    }
  }
// document.querySelector('.enaware-benefits').parentElement.style.height='1050px';

var isLargeGridSelected = false;
  
document.querySelector('.collection-toolbar__layout-switch-list').querySelector('button').forEach((item)=>{
   if(item.classList.contains('is-active')){
      isLargeGridSelected  = item.getAttribute('value') === 'large';
   }
})

if(isLargeGridSelected){
  if(document.querySelectorAll('#product-card-grid-hook').length > 0) document.querySelectorAll('#product-card-grid-hook').forEach((item) => item.classList.toggle('product-grid-large',isGridLarge));  
}
});

document.addEventListener('scroll', function() {
    var scrollPosition = window.scrollY || document.documentElement.scrollTop;
    headerElement.style.backgroundColor = 'rgba(255, 255, 255, '+scrollPosition/1000+')';     
});


function activateLargeGrid(){
  console.log("Activating");
}




 



